import { useApp } from "@/context/AppContext";
import { ASSETS } from "@/lib/site";
import { Seo, PageHeader, SectionTag } from "@/components/common";
import { Cpu, ScanLine, Microscope, BadgeCheck, MapPin } from "lucide-react";

export default function Clinic() {
  const { t } = useApp();
  const tech = [
    { icon: ScanLine, title: { tr: "Dijital ağız içi tarayıcı", en: "Digital intraoral scanner" }, desc: { tr: "Kalıp almadan, dakikalar içinde hassas dijital ölçü.", en: "Precise digital impressions in minutes, without moulds." } },
    { icon: Cpu, title: { tr: "CAD/CAM üretim", en: "CAD/CAM production" }, desc: { tr: "Tasarımdan üretime dijital iş akışı; mikron düzeyinde hassasiyet.", en: "Digital workflow from design to production; micron-level precision." } },
    { icon: Microscope, title: { tr: "Klinik içi laboratuvar", en: "In-house laboratory" }, desc: { tr: "Prova ve düzeltmeler aynı gün yapılır; kalış süreniz kısalır.", en: "Try-ins and adjustments happen the same day; your stay is shorter." } },
  ];

  return (
    <main data-testid="clinic-page">
      <Seo title={t({ tr: "Kliniğimiz", en: "Our Clinic" })} description={t({ tr: "İstanbul'daki kliniğimiz, laboratuvarımız ve kullandığımız dijital teknolojiler.", en: "Our clinic in Istanbul, our laboratory and the digital technologies we use." })} />
      <PageHeader
        tag={{ tr: "Klinik", en: "Clinic" }}
        title={{ tr: "Teknolojiyle desteklenen sakin bir klinik", en: "A calm clinic supported by technology" }}
        subtitle={{ tr: "İstanbul'da, uluslararası hastalar için tasarlanmış ruhsatlı bir sağlık kuruluşu.", en: "A licensed healthcare facility in Istanbul designed for international patients." }}
      />
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-16">
        <img src={ASSETS.clinic} alt={t({ tr: "Klinik iç mekânı", en: "Clinic interior" })} className="w-full h-72 md:h-96 object-cover rounded-2xl" loading="lazy" />
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-16">
        <SectionTag>{t({ tr: "Teknoloji", en: "Technology" })}</SectionTag>
        <h2 className="font-heading text-2xl font-semibold text-[#F2F5F7] tracking-tight">{t({ tr: "Dijital iş akışı", en: "Digital workflow" })}</h2>
        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {tech.map((x, i) => (
            <div key={i} className="rounded-xl glass-card p-8">
              <div className="w-11 h-11 rounded-[10px] bg-[var(--accent-soft)] flex items-center justify-center mb-5">
                <x.icon size={20} className="text-[var(--accent)]" />
              </div>
              <h3 className="font-heading font-semibold text-[#F2F5F7]">{t(x.title)}</h3>
              <p className="text-sm text-[#94A3AE] mt-2 leading-relaxed">{t(x.desc)}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-8">
        <div className="rounded-2xl bg-[#0A0E14] text-white p-8 md:p-12 grid md:grid-cols-2 gap-8">
          <div className="flex gap-4">
            <BadgeCheck size={22} className="text-[var(--accent-2)] shrink-0" />
            <div>
              <h3 className="font-heading font-semibold">{t({ tr: "Resmî yetki", en: "Official authorisation" })}</h3>
              <p className="text-sm text-white/60 mt-2 leading-relaxed" data-testid="clinic-license">
                {t({ tr: "T.C. Sağlık Bakanlığı Sağlık Turizmi Yetki Belgesi No: [Belge no eklenecek]", en: "Republic of Türkiye Ministry of Health — Health Tourism Authorisation No: [to be added]" })}
              </p>
            </div>
          </div>
          <div className="flex gap-4">
            <MapPin size={22} className="text-[var(--accent-2)] shrink-0" />
            <div>
              <h3 className="font-heading font-semibold">{t({ tr: "Adres", en: "Address" })}</h3>
              <p className="text-sm text-white/60 mt-2 leading-relaxed">{t({ tr: "[Klinik adresi eklenecek] · İstanbul, Türkiye", en: "[Clinic address to be added] · Istanbul, Türkiye" })}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
